export const SET_WIDGET_SESSION_ID = 'SET_WIDGET_SESSION_ID'
